import(/* webpackMode: "eager" */ "/workspace/src/frontend/src/app/error.tsx");
